import { render, staticRenderFns } from "./SidebarMenuActionItem.vue?vue&type=template&id=3ddccf38&scoped=true&"
import script from "./SidebarMenuActionItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuActionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuActionItem.vue?vue&type=style&index=0&id=3ddccf38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddccf38",
  null
  
)

export default component.exports